import { useEffect, useRef } from "react";

const GoogleAd = () => {
  const adRef = useRef(null);

  useEffect(() => {
    if (window.adsbygoogle && adRef.current) {
      try {
        window.adsbygoogle.push({});
      } catch (e) {
        console.error("Adsense error", e);
      }
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "inline-block", width: 728, height: 90 }}
      data-ad-client="ca-pub-3312448450681108"
      data-ad-slot="7753782144"
      ref={adRef}
    />
  );
};

export default GoogleAd;